import React, { useEffect } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { mockQuotations } from 'data-layer-cr/dist/__mocks__';

import {
  BasePage,
  colors,
  DefaultButton,
  NetworkIndicator,
} from 'design-system';

import NotificationLayout from '../../components/NotificationLayout';
import trackConfirmationEvent from '../trackConfirmationEvent';

const mockQuotation = mockQuotations.regular;

const useStyles = makeStyles({
  buttonContainer: {
    borderTop: `1px solid ${colors.gallery}`,
    marginLeft: 16,
    marginRight: 16,
    textAlign: 'center',
    padding: 32,
    paddingTop: 20,
  },
});

const image = 'notification_inspector_art.svg';

const getRoleText = (
  role: string,
): { descriptions: string[]; title: string; headerTitle: string } => {
  let roleText = 'corredor';
  if (role === 'ASE') {
    roleText = 'ejecutivo';
  }
  return {
    descriptions: [
      `Recuerda realizar el pago directo a tu ${roleText}.`,
      `Tu ${roleText} realizará el proceso de emisión y pago de la póliza.`,
      `Tu ${roleText} te hará entrega de tu póliza.`,
    ],
    title: `Hemos enviado una notificación a tu ${roleText} para que se encargue de la emisión y el pago.`,
    headerTitle: `Notificación al ${roleText}`,
  };
};

type Props = {
  requesting?: boolean;
  quotationCreator: string;
  onEmissionRequested: () => void;
};

const InspectionNotification = ({
  requesting = false,
  quotationCreator,
  onEmissionRequested,
}: Props): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const classes = useStyles();
  const { descriptions, title, headerTitle } = getRoleText(quotationCreator);
  return (
    <>
      <NetworkIndicator
        data-testid="network-indicator"
        requesting={requesting}
        message="Enviando correo..."
      />
      {!requesting && (
        <BasePage title={headerTitle}>
          <NotificationLayout
            data-testid="content"
            descriptionItems={descriptions}
            titleMessage={title}
            image={image}
          />
          <Grid item xs={12} className={classes.buttonContainer}>
            <Typography style={{ fontWeight: 600 }}>
              ¿Deseas obtener tu póliza más rápido?
            </Typography>
            <Grid item xs={12} style={{ marginTop: 10 }}>
              <DefaultButton
                id="sales-web-inspection-button-modal-client-request"
                data-testid="modal-emission-request-button"
                onClick={(): void => {
                  trackConfirmationEvent('Continúa con el pago', mockQuotation);
                  onEmissionRequested();
                }}
                fullWidth
              >
                Continúa con el pago
              </DefaultButton>
            </Grid>
          </Grid>
        </BasePage>
      )}
    </>
  );
};

export default InspectionNotification;
